module.exports = __webpack_public_path__ + "assets/a1c7f68bbf7d45c565df30555cd6fea5.png";